import { Typography } from '@/components/common';
import clsx from 'clsx';
import { X } from 'lucide-react';
import React from 'react';

interface WelcomeModalHeaderProps {
	title: string;
	description: string;
	onClose: () => void;
	className?: string;
}

export const WelcomeModalHeader: React.FC<WelcomeModalHeaderProps> = ({
	title,
	description,
	onClose,
	className,
}) => {
	return (
		<div
			className={clsx(
				'relative w-full bg-purple-150 rounded-t-[32px] px-10 py-8 flex flex-col items-center text-center',
				className
			)}
		>
			<button
				type="button"
				onClick={onClose}
				className="absolute right-6 top-6 outline-none"
			>
				<X className="w-6 h-6 text-white" />
			</button>
			<Typography type="semibold-20" className="!text-white">
				{title}
			</Typography>
			<Typography type="regular-14" className="!text-white mt-1">
				{description}
			</Typography>
		</div>
	);
};
